/**=========================================================
 * Module: app-sync.js
 * Messages list
 =========================================================*/

 App.directive('appSync', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/sync.html',
        restrict: 'E',
        replace: true,
        controller: 'SyncController',
        scope: { 
            field: '=field',
            code: '=code',
            files: '=files',
            form: '=form',
            model: '=model'
          }
    };
  
  });